import './Newsletter.css';
import * as yup from 'yup';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { newsletterDetails, deleteNewsletter } from '../../../Actions/Newsletter';
import { Button, Typography, CircularProgress } from '@mui/material';
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { newsletterUploadFile } from '../../../Actions/Newsletter';
// import { Form } from 'formik';
import CloseIcon from '@mui/icons-material/Delete';

import axios from 'axios';
import { getNewsletter } from '../../../API/api';
function Newsletter() {
  const dispatch = useDispatch();

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [enable, setenabled] = useState(false);
  const loading = useSelector(state => state.signUpData.isLoading);

  const fileUrl = useSelector(state => state.fileData);
  const fileLoading = useSelector(state => state.fileData.isLoading);
  const [newsletterInfo, setNewsletterInfo] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    axios
      .get(getNewsletter)
      .then(response => {
        setNewsletterInfo(response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const deleteHandler = id => {
    dispatch(deleteNewsletter({ code: id }, userData.token)).then(result => {
      getData();
    });
  };

  const onFileSelected = e => {
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }
  };

  const handleFileUpload = async e => {
    // console.log("inside upload btn")
    e.preventDefault();
    try {
      if (selectedFile !== '') {
        let fileData = new FormData();
        if (selectedFile.type === 'application/pdf') {
          fileData.set('File', selectedFile, `${fileName}.pdf`);
          // console.log(fileData);
          dispatch(newsletterUploadFile(fileData));
          setenabled(true);
        } else toast('Error file uploaded is not of the format .pdf');
      }
    } catch (error) {
      toast(error);
    }
  };

  // console.log(fileUrl)
  const validate = yup.object().shape({
    date: yup.string().required('Required'),
    title: yup.string().required('Required'),
    description: yup.string().required('Required'),
    // docURL: yup.string().required(),
  });
  const userData = JSON.parse(localStorage.getItem('access_token'));

  const formik = useFormik({
    initialValues: {
      date: '',
      title: '',
      description: '',
    },
    validationSchema: validate,

    onSubmit: (values, onSubmitProps) => {
      console.log('inside btn');
      dispatch(
        newsletterDetails(
          {
            code: uuidv4(),
            date: values.date,
            title: values.title,
            description: values.description,
            docURL: fileUrl.newsData,
          },
          userData.token,
        ),
      ).then(response => {
        getData();
        console.log(response);
      });
      onSubmitProps.resetForm();
    },
  });

  // const handleFileUpload = async e => {
  //   e.preventDefault();
  //   try {
  //     if (selectedFile !== '') {
  //       let fileData = new FormData();
  //       if (selectedFile.type === 'application/pdf') {
  //         fileData.set('File', selectedFile, `${Date.now()}.pdf`);
  //         dispatch(uploadFile(fileData));
  //         setenabled(true);
  //       } else toast('Error file uploaded is not of the format .pdf');
  //     }
  //   } catch (error) {
  //     toast(error.message);
  //   }
  // };

  // console.log(newsletterInfo);

  return (
    <div>
      <div>
        <h5 className="h5 head">Enter Details</h5>
      </div>
      <form className="d-flex flex-column container" onSubmit={formik.handleSubmit}>
        <input
          id="title"
          name="title"
          className="input"
          value={formik.values.title}
          type="text"
          placeholder="Enter Heading"
          onChange={formik.handleChange}
          required
        />

        <input
          className="input "
          type="date"
          required
          id="date"
          name="date"
          onChange={formik.handleChange}
          value={formik.values.date}
        />

        <input type="file" onChange={onFileSelected} style={{ marginRight: 0, marginBottom: 20 }} />
        {fileLoading ? (
          <CircularProgress />
        ) : (
          <Button
            sx={{
              backgroundColor: '#16da44',
              color: 'white',
              border: 0,
              width: '350px',
              fontFamily: 'Sora',
              marginBottom: '7px',
              '&:hover': {
                backgroundColor: '#16da44',
              },
            }}
            onClick={e => handleFileUpload(e)}
            className="btn"
          >
            Upload
          </Button>
        )}
        <Typography sx={{ fontFamily: 'Sora', color: 'red', fontSize: '13px' }}>*Please upload .pdf only</Typography>

        <textarea
          className="input"
          type="text"
          id="description"
          name="description"
          value={formik.values.description}
          onChange={formik.handleChange}
          placeholder="Enter description"
          required
        />
        {enable === true ? (
          <Button
            variant="button"
            sx={{
              backgroundColor: '#16da44',
              color: 'white',
              border: 0,
              width: '350px',
              // width: ['100%', '100%', '100%'],
              fontFamily: 'Sora',
              display: 'flex',
              height: '85%',
              justifyContent: 'center',

              '&:hover': {
                backgroundColor: '#16da44',
              },
            }}
            type="submit"
          >
            Submit
          </Button>
        ) : loading ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </div>
        ) : (
          <Button
            variant="button"
            disabled="true"
            sx={{
              backgroundColor: '#67CB45',
              color: 'white',
              border: 0,
              width: '350px',

              // width: ['100%', '100%', '85%'],
              height: '70%',
              fontFamily: 'Sora',

              '&:hover': {
                backgroundColor: '#67CB45',
              },
              display: 'flex',
              justifyContent: 'center',
            }}
            // type="submit"
          >
            Submit
          </Button>
        )}
      </form>

      <div className="div2 my-3">
        <h5 className="h5">Modify Data</h5>
        <div>
          {newsletterInfo.map(data => (
            <div
              style={{
                width: '30%',
                // height: '150px',
                borderRadius: '5px',
                backgroundColor: 'white',
                // boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
                margin: '10px ',
                float: 'left',
                padding: '10px',
              }}
            >
              <div style={{ textAlign: 'end', color: '#FF7345' }}>
                {' '}
                <button onClick={() => deleteHandler(data.code)} style={{ border: 'none', background: 'none' }}>
                  <CloseIcon style={{ color: '#f5363c' }}></CloseIcon>
                </button>
              </div>
              <div
                style={{ color: 'black', fontFamily: 'Sora', margin: '2px 10px', fontWeight: 'bold', fontSize: '18px' }}
              >
                {data.title}
              </div>
              <div style={{ fontFamily: 'Sora', fontSize: '16px', margin: '0 10px' }}>{data.description}</div>
              <div style={{ fontFamily: 'Sora', fontSize: '11px', margin: '0 10px', color: 'grey' }}>{data.date}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Newsletter;
